/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * S Dashboard
 * This is the API specification of S dashboard.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as url from "url";
import * as portableFetch from "isomorphic-fetch";
import { Configuration } from "./configuration";

//first backend
//const BASE_PATH = "http://localhost:50352/v1".replace(/\/+$/, "");
//final backend
const BASE_PATH = (process.env.REACT_APP_BACKEND_PATH || "https://localhost:44378/v1").replace(/\/+$/, "");

/**
 *
 * @export
 */
 export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration!: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name!: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface CCGTMSDreport
 */
export interface CCGTMSDreport {
    /**
     * 
     * @type {string}
     * @memberof CCGTMSDreport
     */
    label?: CCGTMSDreport.LabelEnum;
    /**
     * MSD status in plant's report
     * @type {string}
     * @memberof CCGTMSDreport
     */
    status?: CCGTMSDreport.StatusEnum;
}

/**
 * @export
 * @namespace CCGTMSDreport
 */
export namespace CCGTMSDreport {
    /**
     * @export
     * @enum {string}
     */
    export enum LabelEnum {
        MSD1 = 'MSD1',
        MSD2 = 'MSD2',
        MSD3 = 'MSD3',
        MSD4 = 'MSD4',
        MSD5 = 'MSD5',
        MSD6 = 'MSD6'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        LoadedStatus = <any> 'loadedStatus',
        OnWaitingStatus = <any> 'OnWaitingStatus',
        StopStatus = <any> 'stopStatus'
    }
}

/**
 * 
 * @export
 * @interface CCGTSeries
 */
export interface CCGTSeries {
    /**
     * 
     * @type {Array<TimeSeriesItem>}
     * @memberof CCGTSeries
     */
    prodotto?: Array<TimeSeriesItem>;

    badProdotto?: Array<TimeSeriesItem>;
    
    /**
     * 
     * @type {Array<TimeSeriesItem>}
     * @memberof CCGTSeries
     */
    pv?: Array<TimeSeriesItem>;
    /**
     * 
     * @type {Array<TimeSeriesItem>}
     * @memberof CCGTSeries
     */
    sb?: Array<TimeSeriesItem>;
    /**
     * 
     * @type {Array<TimeSeriesItem>}
     * @memberof CCGTSeries
     */
    pvm?: Array<TimeSeriesItem>;
    /**
     * 
     * @type {Array<TimeSeriesItem>}
     * @memberof CCGTSeries
     */
    pFfromDWH?: Array<TimeSeriesItem>;
    /**
     * 
     * @type {Array<TimeSeriesItem>}
     * @memberof CCGTSeries
     */
    pf?: Array<TimeSeriesItem>;

    psMin1?: Array<TimeSeriesItem>;
    psMin2?: Array<TimeSeriesItem>;
    psMax1?: Array<TimeSeriesItem>;
    psMax2?: Array<TimeSeriesItem>;

    nominalPower: Array<TimeSeriesItem>;
}

/**
 * 
 * @export
 * @interface CCGTdetailsHistory
 */
export interface CCGTdetailsHistory {
    /**
     * 
     * @type {number}
     * @memberof CCGTdetailsHistory
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CCGTdetailsHistory
     */
    plantName?: string;
    
    order: number;

    fullScale: number;
    
    /**
     * 
     * @type {CCGTSeries}
     * @memberof CCGTdetailsHistory
     */
    series?: CCGTSeries;
    /**
     * Valore del load factor mediato sul periodo di riferimento [??]
     * @type {number}
     * @memberof CCGTdetailsHistory
     */
    loadFactor?: number;
    /**
     * valore dell’energia elettrica prodotta durante il periodo di riferimento [GWh]
     * @type {number}
     * @memberof CCGTdetailsHistory
     */
    eeProd?: number;
    /**
     * numero avviamenti TG1 [#]
     * @type {number}
     * @memberof CCGTdetailsHistory
     */
    startTG1?: number;
    /**
     * numero avviamenti TG2 [#]
     * @type {number}
     * @memberof CCGTdetailsHistory
     */
    startTG2?: number;
    /**
     * numero avviamenti TV [#]
     * @type {number}
     * @memberof CCGTdetailsHistory
     */
    startTV?: number;
}

/**
 * 
 * @export
 * @interface CCGTdetailsRealTime
 */
export interface CCGTdetailsRealTime {
    /**
     * 
     * @type {number}
     * @memberof CCGTdetailsRealTime
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CCGTdetailsRealTime
     */
    plantName?: string;

    order: number;

    fullScale: number;
    
    /**
     * 
     * @type {CCGTSeries}
     * @memberof CCGTdetailsRealTime
     */
    series?: CCGTSeries;
    /**
     * 
     * @type {Array<CCGTMSDreport>}
     * @memberof CCGTdetailsRealTime
     */
    msDreport?: Array<CCGTMSDreport>;
    /**
     * Ultimo valore disponibile del piano fattibile per l’impianto [MW]
     * @type {number}
     * @memberof CCGTdetailsRealTime
     */
    feasiblePlan?: number;
    /**
     * Ultimo valore disponibile della potenza d’impianto [MW]
     * @type {number}
     * @memberof CCGTdetailsRealTime
     */
    powerPlant?: number;
    /**
     * Ultimo valore disponibile della potenza generata dal gruppo TG1 [MW]
     * @type {number}
     * @memberof CCGTdetailsRealTime
     */
    powerTG1?: number;
    /**
     * Ultimo valore disponibile della potenza generata dal gruppo TG2 [MW]
     * @type {number}
     * @memberof CCGTdetailsRealTime
     */
    powerTG2?: number;
    /**
     * Ultimo valore disponibile della potenza generata dal gruppo TV [MW]
     * @type {number}
     * @memberof CCGTdetailsRealTime
     */
    powerTV?: number;
    /**
     * Valore cumulato del consumo di gas per la generazione di energia elettrica, calcolato a partire dalle ore 6:00 della giornata corrente [Sm3]
     * @type {number}
     * @memberof CCGTdetailsRealTime
     */
    gasConsumptionSixHours?: number;
}

/**
 * 
 * @export
 * @interface HomePlant
 */
export interface HomePlant {
    /**
     * 
     * @type {number}
     * @memberof HomePlant
     */
    id?: number;
    /**
     * Nome dell’impianto
     * @type {string}
     * @memberof HomePlant
     */
    plantName?: string;
    /**
     * Rappresenta la tecnologia utilizzata nell’impianto (CCGT, Wind o Bioenergie)
     * @type {string}
     * @memberof HomePlant
     */
    type?: HomePlant.TypeEnum;
    /**
     * Latitudine
     * @type {number}
     * @memberof HomePlant
     */
    lat?: number;
    /**
     * Longitudine
     * @type {number}
     * @memberof HomePlant
     */
    lng?: number;
    /**
     * Valore cumulato di energia elettrica prodotta a partire dalle ore 00:00 della giornata corrente [MWh]
     * @type {number}
     * @memberof HomePlant
     */
    eeToday?: number;
    /**
     * Valore cumulato di energia elettrica che verrà prodotta nel corso dell’intera giornata odierna, sulla base del valore previsto dal Forecast [MWh]
     * @type {number}
     * @memberof HomePlant
     */
    prodExpectedToday?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HomePlant
     */
    onProd?: boolean;
    
    powerTg1?: number;
    
    powerTg2?: number;
    /**
     * 
     * @type {number}
     * @memberof HomePlant
     */
    province?: Province;
}

/**
 * @export
 * @namespace HomePlant
 */
export namespace HomePlant {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        Ccgt = 'ccgt',
        Wind = 'wind',
        Bioenergy = 'bioenergy',
        Hydro = 'hydro',
        Solar = 'solar'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum GroupOnProdEnum {
        NonCcgt = <any> 'non-ccgt',
        TG1 = <any> 'TG1',
        TG2 = <any> 'TG2',
        TG12 = <any> 'TG12'
    }
}

/**
 * 
 * @export
 * @interface TimeSeriesItem
 */
export interface TimeSeriesItem {
    /**
     * timeStamp
     * @type {Date}
     * @memberof TimeSeriesItem
     */
    dateKey?: Date;
    /**
     * value [MW] or [MWh]
     * @type {number}
     * @memberof TimeSeriesItem
     */
    value?: number;
}

/**
 * 
 * @export
 * @interface WindBioEnergyDetailsHistory
 */
export interface WindBioEnergyDetailsHistory {
    /**
     *
     * @type {number}
     * @memberof WindBioEnergyDetailsHistory
     */
    id?: number;
    
    /**
     * Nome della vista: Totale; Regionale; Nome dell'impianto per vista singola ('tot', 'region', {plantName})
     * @type {string}
     * @memberof WindBioEnergyDetailsHistory
     */
    viewName?: string;

    order: number;

    fullScale: number;
    
    /**
     * 
     * @type {WindBioEnergySeries}
     * @memberof WindBioEnergyDetailsHistory
     */
    series?: WindBioEnergySeries;
    /**
     * valore cumulato di energia elettrica prodotta nel periodo di riferimento [MWh]
     * @type {number}
     * @memberof WindBioEnergyDetailsHistory
     */
    eeprod?: number;
    /**
     * Valore cumulato di energia elettrica prodotta secondo il valore Forecast [MWh]
     * @type {number}
     * @memberof WindBioEnergyDetailsHistory
     */
    eeForcasted?: number;
}

/**
 * 
 * @export
 * @interface WindBioEnergyDetailsRealTime
 */
export interface WindBioEnergyDetailsRealTime {
    /**
     *
     * @type {number}
     * @memberof WindBioEnergyDetailsRealTime
     */
    id?: number;
    
    /**
     * Nome della vista: Totale; Regionale; Nome dell'impianto per vista singola ('tot', 'region', {plantName})
     * @type {string}
     * @memberof WindBioEnergyDetailsRealTime
     */
    viewName?: string;

    order: number;

    fullScale: number;
    
    /**
     * 
     * @type {WindBioEnergySeries}
     * @memberof WindBioEnergyDetailsRealTime
     */
    series?: WindBioEnergySeries;
    /**
     * valore delle potenze d’impianto attualmente in marcia [MW]
     * @type {number}
     * @memberof WindBioEnergyDetailsRealTime
     */
    powerProd?: number;
    /**
     * valore delle potenze d’impianto calcolato dei piani da Forecast [MW]
     * @type {number}
     * @memberof WindBioEnergyDetailsRealTime
     */
    powerForecasted?: number;
}

/**
 * 
 * @export
 * @interface WindBioEnergySeries
 */
export interface WindBioEnergySeries {
    /**
     * 
     * @type {Array<TimeSeriesItem>}
     * @memberof WindBioEnergySeries
     */
    prodotto?: Array<TimeSeriesItem>;

    badProdotto?: Array<TimeSeriesItem>;
    
    /**
     * 
     * @type {Array<TimeSeriesItem>}
     * @memberof WindBioEnergySeries
     */
    pv?: Array<TimeSeriesItem>;
    /**
     * 
     * @type {Array<TimeSeriesItem>}
     * @memberof WindBioEnergySeries
     */
    forecast?: Array<TimeSeriesItem>;

    nominalPower: Array<TimeSeriesItem>;
}

/**
 * 
 * @export
 * @interface Province
 */
export interface Province {
    /**
     * 
     * @type {number}
     * @memberof Province
     */
    id?: number;
    /**
     * Nome dell’impianto
     * @type {string}
     * @memberof Province
     */
    name?: string;
    /**
     * Nome dell’impianto
     * @type {string}
     * @memberof Province
     */
    description?: string;
}

/**
 * DataPlantApi - fetch parameter creator
 * @export
 */
export const DataPlantApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets real-time data by plant of all ccgt plants with details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsCcgtAllGet(options: any = {}): FetchArgs {
            const localVarPath = `/plants/ccgt/All`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api_key")
					: configuration.apiKey;
                localVarHeaderParameter["api_key"] = localVarApiKeyValue;
            }

            // authentication sdashboard_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("sdashboard_auth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets data by plant of all ccgt plants with details of a given date range.
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsCcgtAllHistoryGet(fromDate: string, toDate: string, options: any = {}): FetchArgs {
            // verify required parameter 'fromDate' is not null or undefined
            if (fromDate === null || fromDate === undefined) {
                throw new RequiredError('fromDate','Required parameter fromDate was null or undefined when calling plantsCcgtAllHistoryGet.');
            }
            // verify required parameter 'toDate' is not null or undefined
            if (toDate === null || toDate === undefined) {
                throw new RequiredError('toDate','Required parameter toDate was null or undefined when calling plantsCcgtAllHistoryGet.');
            }
            const localVarPath = `/plants/ccgt/AllHistory`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api_key")
					: configuration.apiKey;
                localVarHeaderParameter["api_key"] = localVarApiKeyValue;
            }

            // authentication sdashboard_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("sdashboard_auth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substr(0,10) :
                    toDate;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets real time data plant by plant name.
         * @param {string} plantName name of plant to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsCcgtByNameGet(plantName: string, options: any = {}): FetchArgs {
            // verify required parameter 'plantName' is not null or undefined
            if (plantName === null || plantName === undefined) {
                throw new RequiredError('plantName','Required parameter plantName was null or undefined when calling plantsCcgtByNameGet.');
            }
            const localVarPath = `/plants/ccgt/ByName`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api_key")
					: configuration.apiKey;
                localVarHeaderParameter["api_key"] = localVarApiKeyValue;
            }

            // authentication sdashboard_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("sdashboard_auth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (plantName !== undefined) {
                localVarQueryParameter['plantName'] = plantName;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },

        /**
         * Gets history data plant by plant Name.
         * @param {number} plantName NAME plant to return
         * @param {string} fromDate
         * @param {string} toDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsCcgtByNameHistoryGet(plantName: string, fromDate: string, toDate: string, options: any = {}): FetchArgs {
            // verify required parameter 'plantName' is not null or undefined
            if (plantName === null || plantName === undefined) {
                throw new RequiredError('plantName','Required parameter plantName was null or undefined when calling plantsCcgtByNameGet.');
            }
            // verify required parameter 'fromDate' is not null or undefined
            if (fromDate === null || fromDate === undefined) {
                throw new RequiredError('fromDate','Required parameter fromDate was null or undefined when calling plantsCcgtAllHistoryGet.');
            }
            // verify required parameter 'toDate' is not null or undefined
            if (toDate === null || toDate === undefined) {
                throw new RequiredError('toDate','Required parameter toDate was null or undefined when calling plantsCcgtAllHistoryGet.');
            }
            
            const localVarPath = `/plants/ccgt/ByName/History`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
    
            // authentication api_key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("api_key")
                    : configuration.apiKey;
                localVarHeaderParameter["api_key"] = localVarApiKeyValue;
            }
    
            // authentication sdashboard_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("sdashboard_auth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
    
            if (plantName !== undefined) {
                localVarQueryParameter['plantName'] = plantName;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substr(0,10) :
                    toDate;
            }
    
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
    
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets real time data plant by plant Id.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {number} plantName ID plant to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeByNameGet(plantType: 'wind' | 'bioenergy', plantName: string, options: any = {}): FetchArgs {
            // verify required parameter 'plantType' is not null or undefined
            if (plantType === null || plantType === undefined) {
                throw new RequiredError('plantType','Required parameter plantType was null or undefined when calling plantsPlantTypeByNameGet.');
            }
            // verify required parameter 'plantName' is not null or undefined
            if (plantName === null || plantName === undefined) {
                throw new RequiredError('plantName','Required parameter plantName was null or undefined when calling plantsPlantTypeByNameGet.');
            }
            const localVarPath = `/plants/{plantType}/ByName`
                .replace(`{${"plantType"}}`, encodeURIComponent(String(plantType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api_key")
					: configuration.apiKey;
                localVarHeaderParameter["api_key"] = localVarApiKeyValue;
            }

            // authentication sdashboard_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("sdashboard_auth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (plantName !== undefined) {
                localVarQueryParameter['plantName'] = plantName;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets data plant by plant Id in the given data range.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {number} plantId ID plant to return
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeByIdHistoryGet(plantType: 'wind' | 'bioenergy', plantId: number, fromDate: string, toDate: string, options: any = {}): FetchArgs {
            // verify required parameter 'plantType' is not null or undefined
            if (plantType === null || plantType === undefined) {
                throw new RequiredError('plantType','Required parameter plantType was null or undefined when calling plantsPlantTypeByIdHistoryGet.');
            }
            // verify required parameter 'plantId' is not null or undefined
            if (plantId === null || plantId === undefined) {
                throw new RequiredError('plantId','Required parameter plantId was null or undefined when calling plantsPlantTypeByIdHistoryGet.');
            }
            // verify required parameter 'fromDate' is not null or undefined
            if (fromDate === null || fromDate === undefined) {
                throw new RequiredError('fromDate','Required parameter fromDate was null or undefined when calling plantsPlantTypeByIdHistoryGet.');
            }
            // verify required parameter 'toDate' is not null or undefined
            if (toDate === null || toDate === undefined) {
                throw new RequiredError('toDate','Required parameter toDate was null or undefined when calling plantsPlantTypeByIdHistoryGet.');
            }
            const localVarPath = `/plants/{plantType}/ByIdHistory`
                .replace(`{${"plantType"}}`, encodeURIComponent(String(plantType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api_key")
					: configuration.apiKey;
                localVarHeaderParameter["api_key"] = localVarApiKeyValue;
            }

            // authentication sdashboard_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("sdashboard_auth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (plantId !== undefined) {
                localVarQueryParameter['plantId'] = plantId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets real-time data sum of the time series and details grouped by region of all defined plant regions.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeByRegionAllGet(plantType: 'wind' | 'bioenergy', options: any = {}): FetchArgs {
            // verify required parameter 'plantType' is not null or undefined
            if (plantType === null || plantType === undefined) {
                throw new RequiredError('plantType','Required parameter plantType was null or undefined when calling plantsPlantTypeByRegionAllGet.');
            }
            const localVarPath = `/plants/{plantType}/ByRegionAll`
                .replace(`{${"plantType"}}`, encodeURIComponent(String(plantType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api_key")
					: configuration.apiKey;
                localVarHeaderParameter["api_key"] = localVarApiKeyValue;
            }

            // authentication sdashboard_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("sdashboard_auth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets data sum of the time series and details grouped by region of all defined plant regions in the given data range.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeByRegionAllHistoryGet(plantType: 'wind' | 'bioenergy', fromDate: string, toDate: string, options: any = {}): FetchArgs {
            // verify required parameter 'plantType' is not null or undefined
            if (plantType === null || plantType === undefined) {
                throw new RequiredError('plantType','Required parameter plantType was null or undefined when calling plantsPlantTypeByRegionAllHistoryGet.');
            }
            // verify required parameter 'fromDate' is not null or undefined
            if (fromDate === null || fromDate === undefined) {
                throw new RequiredError('fromDate','Required parameter fromDate was null or undefined when calling plantsPlantTypeByRegionAllHistoryGet.');
            }
            // verify required parameter 'toDate' is not null or undefined
            if (toDate === null || toDate === undefined) {
                throw new RequiredError('toDate','Required parameter toDate was null or undefined when calling plantsPlantTypeByRegionAllHistoryGet.');
            }
            const localVarPath = `/plants/{plantType}/ByRegionAllHistory`
                .replace(`{${"plantType"}}`, encodeURIComponent(String(plantType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api_key")
					: configuration.apiKey;
                localVarHeaderParameter["api_key"] = localVarApiKeyValue;
            }

            // authentication sdashboard_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("sdashboard_auth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets real-time data sum of the time series and details of all plants of the given plantType.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeTotalGet(plantType: 'wind' | 'bioenergy', options: any = {}): FetchArgs {
            // verify required parameter 'plantType' is not null or undefined
            if (plantType === null || plantType === undefined) {
                throw new RequiredError('plantType','Required parameter plantType was null or undefined when calling plantsPlantTypeTotalGet.');
            }
            const localVarPath = `/plants/{plantType}/Total`
                .replace(`{${"plantType"}}`, encodeURIComponent(String(plantType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api_key")
					: configuration.apiKey;
                localVarHeaderParameter["api_key"] = localVarApiKeyValue;
            }

            // authentication sdashboard_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("sdashboard_auth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets data sum of the time series and details of all plants of the given plantType and date range.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeTotalHistoryGet(plantType: 'wind' | 'bioenergy', fromDate: string, toDate: string, options: any = {}): FetchArgs {
            // verify required parameter 'plantType' is not null or undefined
            if (plantType === null || plantType === undefined) {
                throw new RequiredError('plantType','Required parameter plantType was null or undefined when calling plantsPlantTypeTotalHistoryGet.');
            }
            // verify required parameter 'fromDate' is not null or undefined
            if (fromDate === null || fromDate === undefined) {
                throw new RequiredError('fromDate','Required parameter fromDate was null or undefined when calling plantsPlantTypeTotalHistoryGet.');
            }
            // verify required parameter 'toDate' is not null or undefined
            if (toDate === null || toDate === undefined) {
                throw new RequiredError('toDate','Required parameter toDate was null or undefined when calling plantsPlantTypeTotalHistoryGet.');
            }
            const localVarPath = `/plants/{plantType}/TotalHistory`
                .replace(`{${"plantType"}}`, encodeURIComponent(String(plantType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api_key")
					: configuration.apiKey;
                localVarHeaderParameter["api_key"] = localVarApiKeyValue;
            }

            // authentication sdashboard_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("sdashboard_auth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataPlantApi - functional programming interface
 * @export
 */
export const DataPlantApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Gets real-time data by plant of all ccgt plants with details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsCcgtAllGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CCGTdetailsRealTime>> {
            const localVarFetchArgs = DataPlantApiFetchParamCreator(configuration).plantsCcgtAllGet(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gets data by plant of all ccgt plants with details of a given date range.
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsCcgtAllHistoryGet(fromDate: string, toDate: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CCGTdetailsHistory>> {
            const localVarFetchArgs = DataPlantApiFetchParamCreator(configuration).plantsCcgtAllHistoryGet(fromDate, toDate, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gets real time data plant by plant Name.
         * @param {number} plantName Name plant to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsCcgtByNameGet(plantName: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CCGTdetailsRealTime>> {
            const localVarFetchArgs = DataPlantApiFetchParamCreator(configuration).plantsCcgtByNameGet(plantName, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        plantsCcgtByNameHistoryGet(plantName: string, fromDate: string, toDate: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CCGTdetailsHistory> {
            const localVarFetchArgs = DataPlantApiFetchParamCreator(configuration).plantsCcgtByNameHistoryGet(plantName, fromDate, toDate, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gets real time data plant by plant Name.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {number} plantName NAME plant to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeByNameGet(plantType: 'wind' | 'bioenergy', plantName: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<WindBioEnergyDetailsRealTime>> {
            const localVarFetchArgs = DataPlantApiFetchParamCreator(configuration).plantsPlantTypeByNameGet(plantType, plantName, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gets data plant by plant Id in the given data range.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {number} plantId ID plant to return
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeByIdHistoryGet(plantType: 'wind' | 'bioenergy', plantId: number, fromDate: string, toDate: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<WindBioEnergyDetailsRealTime>> {
            const localVarFetchArgs = DataPlantApiFetchParamCreator(configuration).plantsPlantTypeByIdHistoryGet(plantType, plantId, fromDate, toDate, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gets real-time data sum of the time series and details grouped by region of all defined plant regions.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeByRegionAllGet(plantType: 'wind' | 'bioenergy', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<WindBioEnergyDetailsRealTime>> {
            const localVarFetchArgs = DataPlantApiFetchParamCreator(configuration).plantsPlantTypeByRegionAllGet(plantType, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gets data sum of the time series and details grouped by region of all defined plant regions in the given data range.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeByRegionAllHistoryGet(plantType: 'wind' | 'bioenergy', fromDate: string, toDate: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<WindBioEnergyDetailsHistory>> {
            const localVarFetchArgs = DataPlantApiFetchParamCreator(configuration).plantsPlantTypeByRegionAllHistoryGet(plantType, fromDate, toDate, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gets real-time data sum of the time series and details of all plants of the given plantType.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeTotalGet(plantType: 'wind' | 'bioenergy', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<WindBioEnergyDetailsRealTime>> {
            const localVarFetchArgs = DataPlantApiFetchParamCreator(configuration).plantsPlantTypeTotalGet(plantType, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gets data sum of the time series and details of all plants of the given plantType and date range.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeTotalHistoryGet(plantType: 'wind' | 'bioenergy', fromDate: string, toDate: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<WindBioEnergyDetailsHistory>> {
            const localVarFetchArgs = DataPlantApiFetchParamCreator(configuration).plantsPlantTypeTotalHistoryGet(plantType, fromDate, toDate, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DataPlantApi - factory interface
 * @export
 */
export const DataPlantApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Gets real-time data by plant of all ccgt plants with details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsCcgtAllGet(options?: any) {
            return DataPlantApiFp(configuration).plantsCcgtAllGet(options)(fetch, basePath);
        },
        /**
         * Gets data by plant of all ccgt plants with details of a given date range.
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsCcgtAllHistoryGet(fromDate: string, toDate: string, options?: any) {
            return DataPlantApiFp(configuration).plantsCcgtAllHistoryGet(fromDate, toDate, options)(fetch, basePath);
        },
        /**
         * Gets real time data plant by plant Name.
         * @param {number} plantName NAME plant to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsCcgtByNameGet(plantName: string, options?: any) {
            return DataPlantApiFp(configuration).plantsCcgtByNameGet(plantName, options)(fetch, basePath);
        },
        plantsCcgtByNameHistoryGet(plantName: string, fromDate: string, toDate: string, options?: any) {
            return DataPlantApiFp(configuration).plantsCcgtByNameHistoryGet(plantName, fromDate, toDate, options)(fetch, basePath);
        },
        /**
         * Gets real time data plant by plant Name.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {number} plantName NAME plant to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeByNameGet(plantType: 'wind' | 'bioenergy', plantName: string, options?: any) {
            return DataPlantApiFp(configuration).plantsPlantTypeByNameGet(plantType, plantName, options)(fetch, basePath);
        },
        /**
         * Gets data plant by plant Id in the given data range.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {number} plantId ID plant to return
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeByIdHistoryGet(plantType: 'wind' | 'bioenergy', plantId: number, fromDate: string, toDate: string, options?: any) {
            return DataPlantApiFp(configuration).plantsPlantTypeByIdHistoryGet(plantType, plantId, fromDate, toDate, options)(fetch, basePath);
        },
        /**
         * Gets real-time data sum of the time series and details grouped by region of all defined plant regions.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeByRegionAllGet(plantType: 'wind' | 'bioenergy', options?: any) {
            return DataPlantApiFp(configuration).plantsPlantTypeByRegionAllGet(plantType, options)(fetch, basePath);
        },
        /**
         * Gets data sum of the time series and details grouped by region of all defined plant regions in the given data range.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeByRegionAllHistoryGet(plantType: 'wind' | 'bioenergy', fromDate: string, toDate: string, options?: any) {
            return DataPlantApiFp(configuration).plantsPlantTypeByRegionAllHistoryGet(plantType, fromDate, toDate, options)(fetch, basePath);
        },
        /**
         * Gets real-time data sum of the time series and details of all plants of the given plantType.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeTotalGet(plantType: 'wind' | 'bioenergy', options?: any) {
            return DataPlantApiFp(configuration).plantsPlantTypeTotalGet(plantType, options)(fetch, basePath);
        },
        /**
         * Gets data sum of the time series and details of all plants of the given plantType and date range.
         * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantsPlantTypeTotalHistoryGet(plantType: 'wind' | 'bioenergy', fromDate: string, toDate: string, options?: any) {
            return DataPlantApiFp(configuration).plantsPlantTypeTotalHistoryGet(plantType, fromDate, toDate, options)(fetch, basePath);
        },
    };
};

/**
 * DataPlantApi - object-oriented interface
 * @export
 * @class DataPlantApi
 * @extends {BaseAPI}
 */
export class DataPlantApi extends BaseAPI {
    /**
     * Gets real-time data by plant of all ccgt plants with details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataPlantApi
     */
    public plantsCcgtAllGet(options?: any) {
        return DataPlantApiFp(this.configuration).plantsCcgtAllGet(options)(this.fetch, this.basePath);
    }

    /**
     * Gets data by plant of all ccgt plants with details of a given date range.
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataPlantApi
     */
    public plantsCcgtAllHistoryGet(fromDate: string, toDate: string, options?: any) {
        return DataPlantApiFp(this.configuration).plantsCcgtAllHistoryGet(fromDate, toDate, options)(this.fetch, this.basePath);
    }

    /**
     * Gets real time data plant by plant Name.
     * @param {number} plantName NAME plant to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataPlantApi
     */
    public plantsCcgtByNameGet(plantName: string, options?: any) {
        return DataPlantApiFp(this.configuration).plantsCcgtByNameGet(plantName, options)(this.fetch, this.basePath);
    }

    /**
     * Gets real time data plant by plant Id.
     * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
     * @param {number} plantId ID plant to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataPlantApi
     */
    public plantsPlantTypeByIdGet(plantType: 'wind' | 'bioenergy', plantName: string, options?: any) {
        return DataPlantApiFp(this.configuration).plantsPlantTypeByNameGet(plantType, plantName, options)(this.fetch, this.basePath);
    }

    /**
     * Gets data plant by plant Id in the given data range.
     * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
     * @param {number} plantId ID plant to return
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataPlantApi
     */
    public plantsPlantTypeByIdHistoryGet(plantType: 'wind' | 'bioenergy', plantId: number, fromDate: string, toDate: string, options?: any) {
        return DataPlantApiFp(this.configuration).plantsPlantTypeByIdHistoryGet(plantType, plantId, fromDate, toDate, options)(this.fetch, this.basePath);
    }

    /**
     * Gets real-time data sum of the time series and details grouped by region of all defined plant regions.
     * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataPlantApi
     */
    public plantsPlantTypeByRegionAllGet(plantType: 'wind' | 'bioenergy', options?: any) {
        return DataPlantApiFp(this.configuration).plantsPlantTypeByRegionAllGet(plantType, options)(this.fetch, this.basePath);
    }

    /**
     * Gets data sum of the time series and details grouped by region of all defined plant regions in the given data range.
     * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataPlantApi
     */
    public plantsPlantTypeByRegionAllHistoryGet(plantType: 'wind' | 'bioenergy', fromDate: string, toDate: string, options?: any) {
        return DataPlantApiFp(this.configuration).plantsPlantTypeByRegionAllHistoryGet(plantType, fromDate, toDate, options)(this.fetch, this.basePath);
    }

    /**
     * Gets real-time data sum of the time series and details of all plants of the given plantType.
     * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataPlantApi
     */
    public plantsPlantTypeTotalGet(plantType: 'wind' | 'bioenergy', options?: any) {
        return DataPlantApiFp(this.configuration).plantsPlantTypeTotalGet(plantType, options)(this.fetch, this.basePath);
    }

    /**
     * Gets data sum of the time series and details of all plants of the given plantType and date range.
     * @param {'wind' | 'bioenergy'} plantType Rappresenta la tecnologia utilizzata nell’impianto (Wind o Bioenergie)
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataPlantApi
     */
    public plantsPlantTypeTotalHistoryGet(plantType: 'wind' | 'bioenergy', fromDate: string, toDate: string, options?: any) {
        return DataPlantApiFp(this.configuration).plantsPlantTypeTotalHistoryGet(plantType, fromDate, toDate, options)(this.fetch, this.basePath);
    }

}

/**
 * GlobalApi - fetch parameter creator
 * @export
 */
export const GlobalApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalAllPlantsGet(options: any = {}): FetchArgs {
            const localVarPath = `/global/AllPlants`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api_key")
					: configuration.apiKey;
                localVarHeaderParameter["api_key"] = localVarApiKeyValue;
            }

            // authentication sdashboard_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("sdashboard_auth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalTotKPIGet(options: any = {}): FetchArgs {
            const localVarPath = `/global/TotKPI`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api_key")
					: configuration.apiKey;
                localVarHeaderParameter["api_key"] = localVarApiKeyValue;
            }

            // authentication sdashboard_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("sdashboard_auth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalApi - functional programming interface
 * @export
 */
export const GlobalApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalAllPlantsGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<HomePlant>> {
            const localVarFetchArgs = GlobalApiFetchParamCreator(configuration).globalAllPlantsGet(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * GlobalApi - factory interface
 * @export
 */
export const GlobalApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalAllPlantsGet(options?: any) {
            return GlobalApiFp(configuration).globalAllPlantsGet(options)(fetch, basePath);
        },
    };
};

/**
 * GlobalApi - object-oriented interface
 * @export
 * @class GlobalApi
 * @extends {BaseAPI}
 */
export class GlobalApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalApi
     */
    public globalAllPlantsGet(options?: any) {
        return GlobalApiFp(this.configuration).globalAllPlantsGet(options)(this.fetch, this.basePath);
    }

}

